import type { RouteRecordRaw } from 'vue-router'
import InvestIndex from '@/views/frontDesk/invest/index.vue'
import FdInvestDetail from '@/views/frontDesk/invest/detail.vue'
import FdInvestList from '@/views/frontDesk/invest/list.vue'
import FdInvestTabel from '@/views/frontDesk/invest/tabel.vue'
import FdInvestStatList from '@/views/frontDesk/invest/statList.vue'

// 招商活动
export const InvestRoute: Array<RouteRecordRaw> = [
  {
    path: 'investIndex',
    name: 'InvestIndex',
    meta: {
      title: '楼盘招商' 
    },
    component: InvestIndex
  },
  {
    path: 'fdInvestList/fdInvestDetail/:id',
    name: 'FdInvestDetail',
    meta: {
      title: '招商详情' 
    },
    component: FdInvestDetail
  },
  {
    path: 'fdInvestList',
    name: 'FdInvestList',
    meta: {
      title: '招商列表' 
    },
    component: FdInvestList
  },
  {
    path: 'fdInvestList/fdInvestTabel/:id',
    name: 'FdInvestTabel',
    meta: {
      title: '会员报名表' 
    },
    component: FdInvestTabel
  },
  {
    path: 'fdInvestStat',
    name: 'FdInvestStat',
    meta: {
      title: '全国招商项目统计' 
    },
    component: FdInvestStatList
  },
]

export default InvestRoute